import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
`;

const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    var(--primary-color) 0%,
    var(--background-dark) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${fadeIn} 0.3s ease;
`;

const LoaderContent = styled.div`
  text-align: center;
  color: white;
`;

const LogoContainer = styled.div`
  margin-bottom: 30px;
  animation: ${pulse} 2s ease-in-out infinite;

  img {
    max-width: 150px;
    height: auto;
  }
`;

const SpinnerContainer = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 30px;
`;

const Spinner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: var(--secondary-color);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const SpinnerInner = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: white;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite reverse;
`;

const LoadingText = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  margin-bottom: 10px;
  font-family: "Inter", sans-serif;
`;

const LoadingSubtext = styled.div`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  font-family: "Inter", sans-serif;
`;

const ContainerIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 20px;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const Loader = ({ message = "Loading...", subtext = "Please wait" }) => {
  return (
    <LoaderWrapper>
      <LoaderContent>
        <ContainerIcon>
          <i className="fas fa-shipping-fast"></i>
        </ContainerIcon>

        <SpinnerContainer>
          <Spinner />
          <SpinnerInner />
        </SpinnerContainer>

        <LoadingText>{message}</LoadingText>
        <LoadingSubtext>{subtext}</LoadingSubtext>
      </LoaderContent>
    </LoaderWrapper>
  );
};

export default Loader;
